import hexToRGBA from "../../../hexToRGBA";
import { InternalThemeConfig } from "../../config";

const toggleButton = ({ palette, shadows, spacing }: InternalThemeConfig) => {
	const primary12 = hexToRGBA(palette.primary, 0.12);

	return {
		root: {
			color: palette.primary,
			fontStyle: "normal",
			backgroundColor: "inherit",
			padding: "2.1rem 3.2rem 1.9rem 3.2rem",
			fontFamily: "RoobertCEZ",
			"&.Mui-selected": {
				color: palette.white,
				background: `linear-gradient(135deg, ${palette.lightPrimary} 0%, ${palette.primary} 100%)`,
				boxShadow: `${shadows.shadowPrimaryMedium}`,
			},
			"&:hover": {
				backgroundColor: primary12,
			},
		},
		sizeSmall: {
			padding: `${spacing(1.5)} ${spacing(3)}`,
			fontSize: spacing(1.75),
		},
	};
};

export default toggleButton;
